import { render } from "./Log.vue?vue&type=template&id=6bccba2c"
import script from "./Log.vue?vue&type=script&lang=js"
export * from "./Log.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__